import React from 'react';

import { ForecastPaginatedControls } from 'src/features/forecastPaginated/forecastPaginatedControls/ForecastPaginatedControls';
import { ForecastPaginatedControlsSkeleton } from 'src/features/forecastPaginated/forecastPaginatedControls/ForecastPaginatedControlsSkeleton';
import type { ForecastDataPoint } from 'src/types/domain/ForecastDataPoint';

type ForecastPaginatedControlsContainerProps = {
  sessionId?: string;
  sku?: string | null;
  data: ForecastDataPoint[];
  isLoading: boolean;
};

export function ForecastPaginatedControlsContainer({
  sessionId,
  sku,
  data,
  isLoading,
}: ForecastPaginatedControlsContainerProps) {
  return (
    <>
      {data && sku && sessionId && !isLoading ? (
        <ForecastPaginatedControls
          sessionId={sessionId}
          sku={sku}
          data={data}
        />
      ) : (
        <ForecastPaginatedControlsSkeleton />
      )}
    </>
  );
}
